const { CNavLink } = require('@coreui/react-pro')
const { Link } = require('react-router-dom')

const RouterNavLink = (props) => <CNavLink component={Link} {...props} />

export default RouterNavLink
